// extracted by mini-css-extract-plugin
export var danger = "_2z-6";
export var lightPink = "_2z-a";
export var medium = "_2z-j";
export var nearSquare = "_2z-m";
export var neutralBlue = "_2z-8";
export var neutralYellow = "_2z-7";
export var noCapitalize = "_2z-1";
export var normal = "_2z-2";
export var pill = "_2z-0";
export var primary = "_2z-3";
export var primaryLight = "_2z-4";
export var shadow = "_2z-n";
export var small = "_2z-k";
export var solidBlack = "_2z-i";
export var solidGreen = "_2z-d";
export var solidLightBlue = "_2z-f";
export var solidNavy = "_2z-e";
export var solidOrange = "_2z-h";
export var solidPink = "_2z-g";
export var solidRed = "_2z-b";
export var solidWhite = "_2z-9";
export var solidYellow = "_2z-c";
export var success = "_2z-5";
export var xsmall = "_2z-l";